import React from 'react';
import { Truck, Lock, DollarSign, MapPin, ArrowRight, CheckCircle, HardHat } from 'lucide-react';
import SEO from '../components/SEO';

const CommercialYardStorage = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            <SEO
                title="Commercial Yard Storage | VD Storage Bells"
                description="Open-yard storage for contractors, equipment, trailers, and business materials in Bells, TX."
                canonical="/commercial-yard-storage-bells"
            />
            {/* Hero Section */}
            <section className="bg-gray-900 text-white py-20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <h1 className="text-4xl md:text-5xl font-bold mb-6">
                        Commercial Yard Storage in Bells, TX
                    </h1>
                    <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8">
                        Laydown yards and fleet parking for local businesses. Store your heavy equipment securely.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <a
                            href="https://vdstoragebells.mysms360.com/rent?utm_source=vdstoragebells.com&utm_content=commercial"
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={() => {
                                if (window.gtag) {
                                    window.gtag('event', 'conversion_intent', {
                                        'event_category': 'lead',
                                        'event_label': 'commercial_hero_rates',
                                        'facility_name': 'VD Storage Bells'
                                    });
                                }
                            }}
                            className="inline-flex items-center px-8 py-3 text-lg font-semibold text-gray-900 bg-white rounded-lg hover:bg-gray-100 transition-colors shadow-lg"
                        >
                            See Commercial Rates
                            <ArrowRight className="ml-2 h-5 w-5" />
                        </a>
                    </div>
                </div>
            </section>

            {/* Main Content */}
            <section className="py-16 bg-white">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="prose prose-lg max-w-none mb-12">
                        <h2 className="text-3xl font-bold text-gray-900 mb-6">Built for Business</h2>
                        <p className="text-xl text-gray-700 leading-relaxed mb-6">
                            Run your business without cluttering your home or paying for expensive commercial real estate.
                            <strong>VD Storage Bells</strong> offers specialized outdoor storage for commercial needs.
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                                <Truck className="h-6 w-6 text-blue-600 mr-2" />
                                Fleet Parking
                            </h3>
                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-1" />
                                    <span>Landscaping Trucks & Trailers</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-1" />
                                    <span>Delivery Vans</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-1" />
                                    <span>Utility Vehicles</span>
                                </li>
                            </ul>
                        </div>

                        <div className="bg-gray-50 p-6 rounded-xl border border-gray-100">
                            <h3 className="text-xl font-bold text-gray-900 mb-4 flex items-center">
                                <HardHat className="h-6 w-6 text-blue-600 mr-2" />
                                Laydown Yards
                            </h3>
                            <ul className="space-y-3">
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-1" />
                                    <span>Heavy Equipment Storage</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-1" />
                                    <span>Construction Materials</span>
                                </li>
                                <li className="flex items-start">
                                    <CheckCircle className="h-5 w-5 text-green-500 mr-2 mt-1" />
                                    <span>Machinery Parking</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CommercialYardStorage;
